import { render, staticRenderFns } from "./babyAvatar.vue?vue&type=template&id=74ce3764&scoped=true&"
import script from "./babyAvatar.vue?vue&type=script&lang=js&"
export * from "./babyAvatar.vue?vue&type=script&lang=js&"
import style0 from "./babyAvatar.vue?vue&type=style&index=0&id=74ce3764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ce3764",
  null
  
)

export default component.exports